import { useContext, useEffect } from "react";

import { AuthContext } from "../../../Auth/AuthContext";
import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

import { useGlobalRegisters } from "../../../GlobalRegisters/GlobalRegistersContext";

const SocketNotifications = ({
  setNotifications,
  setDesktopNotifications,
  ticketIdRef,
  handleNotifications
}) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();
  const { user } = useContext(AuthContext);
  const { getSetting, allUsers, isLoading } = useGlobalRegisters();



  //  ***************
  //  ** Functions **
  //  ***************
  const notBelongsToUserWhatsapps = ticket => {
    if (!ticket || ticket === undefined) return true;
    if ([1, 2, 3, 4].includes(ticket.type)) return true;
    if (!user.whatsapps || user.whatsapps.length <= 0) return true;

    let ticketVisible = false;

    user.whatsapps.forEach((whatsapp) => {
      if (ticketVisible) return;
      ticketVisible = whatsapp.id === ticket.whatsappId;
    });

    return ticketVisible;
  }



  //  ****************
  //  ** Use Effect **
  //  ****************
  useEffect(() => {
    if (isLoading) return;

    const socket = getSocket();

    if (socket) {
      const handleNotification = async (data) => {
        const isTenantIdValid = `${api.defaults.headers.tenantId}` === `${data.tenantId}`;
        if (!isTenantIdValid) return;

        const belongingUserWhatsapp = notBelongsToUserWhatsapps(data.ticket);

        const isDeleteTicketOrUnreadMessage = ["updateUnreadNotification", "deleteNotification"].includes(data.action)
          && belongingUserWhatsapp;

        const isTicketTransferring = data.action === "transferNotification"
          && data.ticket.status === "open"
          && (data.ticket.userId === user?.id || !data.ticket.userId)
          && belongingUserWhatsapp;

        const isNewMessage = data.action === "createNotification" && belongingUserWhatsapp;

        if (isDeleteTicketOrUnreadMessage) {
          setNotifications(previous => {
            const index = previous.findIndex(notification =>
              notification.ticket.id === data.ticketId && [user.id, -1].includes(notification.notifiedUser)
            );
  
            if (index !== -1) {
              if (
                (data.action === "deleteNotification")
                || (data.action === "updateUnreadNotification" && previous[index].ticket.status !== "group")
              ) {
                previous.splice(index, 1);
                return [...previous];
              }

              if ([previous[index].notifiedUser, -1].includes(data.userId)) {
                previous.splice(index, 1);
                return [...previous];
              }
  
              return previous;
            }
  
            return previous;
          });
  
          setDesktopNotifications(notifications => {
            const index = notifications.findIndex(notification => notification.tag === String(data.ticketId));

            if (index !== -1) {
              notifications[index].close();
              notifications.splice(index, 1);
              return [...notifications];
            }
            
            return notifications;
          });
        }
        else if (isTicketTransferring) {
          const sendNotificationsChatsGroupsValue = getSetting("sendNotificationsChatsGroups");
          const sendNotificationsValue = getSetting("sendNotifications");
  
          setNotifications(previous => {
            const index = previous.findIndex(notification =>
              notification.ticket.id === data.ticket.id && [user.id, -1].includes(notification.notifiedUser)
            );
  
            if (index !== -1) {
              previous[index].ticket = data.ticket;
              return [...previous];
            }
  
            return [{ notifiedUser: -1, ticket: data.ticket }, ...previous];
          });
  
          const isUserIdCurrent = data.ticket.userId && data.ticket.userId !== user?.id;
          const isInternalUserIdCurrent = data.ticket.userIdInternalChat && data.ticket.userIdInternalChat !== user?.id;

          const shouldNotNotificate = [0, 1, 2].includes(data.ticket.type)
            ? isUserIdCurrent
            : isUserIdCurrent && isInternalUserIdCurrent;

          if (shouldNotNotificate) return;          
          handleNotifications(data, sendNotificationsChatsGroupsValue, sendNotificationsValue);
        }
        else if (isNewMessage) {
          const adminsPendingTicketsControlValue = getSetting("adminsPendingTicketsControl");
    
          const shouldSkipNewMessage = adminsPendingTicketsControlValue === "enabled"
            && user.profile !== "admin"
            && data.ticket.status === "pending";

          if (shouldSkipNewMessage) return;

          const sendNotificationsChatsGroupsValue = getSetting("sendNotificationsChatsGroups");
          const sendNotificationsValue = getSetting("sendNotifications");

          const chatNotificationCondition = (sendNotificationsValue === "both" && ["open", "pending"].includes(data.ticket?.status))
            || (sendNotificationsValue === "open" && data.ticket?.status === "open")
            || (sendNotificationsValue === "pending" && data.ticket?.status === "pending");
  
          const notificationSettingCondition = (sendNotificationsChatsGroupsValue === "both" && (data.ticket?.status === "group" || chatNotificationCondition))
            || (sendNotificationsChatsGroupsValue === "groups" && data.ticket?.status === "group")
            || (sendNotificationsChatsGroupsValue === "chats" && chatNotificationCondition);

          if (!notificationSettingCondition) return;
          
          const isUserIdCondition = data.ticket.userId === user?.id || !data.ticket.userId;
          const isInternalUserIdCondition = data.ticket.type === 3 && data.message.userIdInternalChat === user?.id;
          
          const isCurrentCondition = (!data.message.read && isUserIdCondition) || (isInternalUserIdCondition);
          if (!isCurrentCondition) return;

          setNotifications(previous => {
            const index = previous.findIndex(notification =>
              notification.ticket.id === data.ticket.id && [user.id, -1].includes(notification.notifiedUser)
            );

            if (index !== -1) {
              previous[index].ticket = data.ticket;
              return [...previous];
            }
            
            if (data.ticket.status === "group") {
              const groupNotifications = allUsers.map(user => ({ notifiedUser: user.id, ticket: data.ticket }));
              return [...groupNotifications, ...previous];
            }
          
            return [{ notifiedUser: -1, ticket: data.ticket, }, ...previous];
          });
    
          const isUserIdCurrent = data.ticket.userId && data.ticket.userId !== user?.id;
          const isInternalUserIdCurrent = data.ticket.userIdInternalChat && data.ticket.userIdInternalChat !== user?.id;

          const shouldNotNotificate = [0, 1, 2].includes(data.message.ticket.type)
            ? isUserIdCurrent
            : isUserIdCurrent && isInternalUserIdCurrent;

          if (shouldNotNotificate) return;
          handleNotifications(data, sendNotificationsChatsGroupsValue, sendNotificationsValue);
        }   
      };
  
      socket.on("notification", handleNotification);
      return () => socket.off("notification", handleNotification);
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSetting, allUsers, isLoading, setNotifications, setDesktopNotifications, ticketIdRef, handleNotifications]);



  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketNotifications;